<script setup>
import menus from "~/configs/menu";
import SocialMedia from "~/components/AppFooter/SocialMedia.vue";

const props = defineProps({
    customMenu: Array,
    isMoto: {
      type: Boolean,
      default: false
    },
    isSectionScrolling: {
      type: Boolean,
      default: false
    }
})

const { blendEffect } = useBlend();

const visible = defineModel('visible');
const open = ref(visible.value);

blendEffect(visible, true, true, false, () => {
  if(visible.value) visible.value = false;
});

const hideMenu = () => {
  if(!open.value) return;
  visible.value = false;
}

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  }
};

const handlePressSectionScrolling = (menu) => {
  const route = useRoute();
  const isOnPressHome = route.path === '/biuro-prasowe';
  
  if (!isOnPressHome) {
    const router = useRouter();
    router.push('/biuro-prasowe');
    
    router.afterEach(() => {
      setTimeout(() => {
        const sectionId = menu.path?.replace('#', '') || menu.sectionId || menu.slug;
        if (sectionId) {
          scrollToSection(sectionId);
        }
      }, 100);
    });
  } else {
    const sectionId = menu.path?.replace('#', '') || menu.sectionId || menu.slug;
    if (sectionId) {
      scrollToSection(sectionId);
    }
  }
};

const handleMenuClick = (menu) => {
  if (props.isSectionScrolling) {
    handlePressSectionScrolling(menu);
  }
  navigateTo(menu.path || menu.url || '/');
  visible.value = false;
}
</script>

<template>
  <div class="🟠 mobile-menu | fixed z-50 bg-white w-64 top-10 bottom-0 pt-32 -right-64 transition-all duration-300 xl:hidden"
       :class="{'!right-0': visible}"
       @transitionend="open = visible"
       @touchmove.passive.prevent=""
       v-click-outside="() => hideMenu()"
  >
    <div class="flex flex-col h-full">
      <div class="flex flex-col w-full grow px-8">
        <div v-for="menu in props.customMenu? props.customMenu: menus"
             :key="menu.id || menu.slug"
             @click="handleMenuClick(menu)"
             class="font-extralight text-lg hover:text-azure cursor-pointer transition-colors py-2"
        >
          {{ menu.label ? menu.label : menu.name || menu.title }}
        </div>
        <NuxtLink href="/moto" target="_blank" class="h-7 flex flex-col justify-center" v-if="!isMoto">
          <VectorMoto />
        </NuxtLink>
      </div>
      <div class="bg-gray-100 py-8 mt-8 px-8">
        <SocialMedia noVehisLogos forceColumn />
      </div>
    </div>
  </div>
</template>
